module.exports = "<div class=\"form-group row ccForm\" [formGroup]=\"creditCardForm\" style=\"margin-top:1;height:100%;\">\r\n  <!-- <label class=\"control-label\">Card Number</label> -->\r\n  <!-- <input type=\"hidden\" formControlName=\"CardNumber\" /> -->\r\n  <iframe class=\"payFrame\" height=\"200\" scrolling=\"no\" [src]=\"iframe | safe\" id=\"ccFrame\"></iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/credit-card-iframe/credit-card-iframe.component.html
// module id = ../../../../../src/app/component/credit-card-iframe/credit-card-iframe.component.html
// module chunks = main